<template>
  <section id="home" class="pt-24 pb-16 md:pt-32 md:pb-24">
    <div class="container mx-auto px-4">
      <div class="flex flex-col md:flex-row items-center">
        <div class="md:w-1/2 mb-10 md:mb-0">
          <h1
            class="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight md:leading-normal mb-6"
          >
            <span class="block">Gigcep ile</span>
            <span class="gig-landing-text-purple"> Gigleri tamamla, </span>
            <span class="block">hediyeler kazan.</span>
          </h1>
          <p class="text-xl text-gray-600 mb-8 max-w-lg">
            Boş zamanlarınızı değere dönüştürün. Gigcep'le basit gigleri
            tamamlayarak gerçek ödüller kazanın.
          </p>

          <div class="flex flex-row items-center justify-start gap-8 mb-6">
            <div>
              <NuxtImg
                src="/img/download/google-play.png"
                width="200"
                height="60"
                class="cursor-pointer rounded-lg"
                alt="Google Play Store"
                @click="openMobilAppUrl"
              />
            </div>
            <div>
              <NuxtImg
                src="/img/download/app-store.webp"
                width="200"
                height="60"
                class="cursor-pointer rounded-lg"
                alt="Apple App Store"
                @click="openMobilAppWebUrl"
              />
            </div>
          </div>
        </div>

        <div class="md:w-1/2 flex justify-center md:justify-end">
          <div class="relative">
            <div
              class="absolute -inset-1 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-3xl blur-lg opacity-75 animate-pulse"
            ></div>
            <div class="relative rounded-3xl shadow-xl overflow-hidden border">
              <!-- <img
                src="https://images.pexels.com/photos/6347720/pexels-photo-6347720.jpeg?auto=compress&cs=tinysrgb&w=600"
                alt="Gigcep App Preview"
                class="w-64 md:w-72 h-auto rounded-2xl transform transition-transform duration-300 hover:scale-105"
              /> -->
              <img
                class="bg-transparent w-full max-w-xl h-auto rounded-full transform transition-transform duration-300 hover:scale-105"
                src="/img/login/gig.png"
                alt="Gigcep"
                width="1200"
                height="996"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
function openMobilAppUrl() {
  window.open(
    "https://play.google.com/store/apps/details?id=com.gigcep.app",
    "_blank",
  )
}

function openMobilAppWebUrl() {
  window.open("https://m.gigcep.com/", "_blank")
}
</script>
